import { ShieldCheck } from 'lucide-react'

export function WorkflowHeader() {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <ShieldCheck className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h2 className="text-2xl font-display font-bold">JFAC Software Assurance Workflow</h2>
          <p className="text-muted-foreground">
            Guided execution of the JFAC 2019 Software Assurance process.
          </p>
        </div>
      </div>
    </div>
  )
}
